import React from "react";
// import blackShoe from "../../../assets/icons/blackshoe.svg";
// import shoeIcon from "../../../assets/icons/shoe.svg";
// import SoccerBall from "../../../assets/icons/soccerr.svg";
import { useTranslation } from 'react-i18next';
import * as moment from 'moment';
import bettingService from "../../../api/services/bettingService";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { BiFootball } from 'react-icons/bi';
import { GiStrikingArrows } from "react-icons/gi";
import { GiSoccerBall } from "react-icons/gi";


const SelectedMatchesCard = ({ match, expand , showHideDetails }) => {

    const { t } = useTranslation();
    const language = localStorage.getItem("language");
    const [data, setData] = useState(null);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setData(null);
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const response = await bettingService.bettingHistoryDetails({
                    gamblingId: Number(match.gamblingId),
                    status: "Inplay",
                });
                const res = await response.json();
                if (res && res.length > 0) {
                    setData({ ...match, ...res[0] });
                }
            } catch (err) {
                if (err?.response?.status === 401) {
                    // Redirect to the login page
                    navigate("/login");
                } else {
                    console.error("API request error:", err);
                }
            } finally {
                setIsLoading(false);
            }
        };
        match.gamblingTypeId === 1 && fetchData();
    }, [match, navigate]);

    return (

    <div className='flex flex-col pt-4 pb-2 mx-1 my-2 rounded-md h-max dark:border dark:border-border_rule_btn/[0.1] border-2 border-slate-200 dark:text-white font-myanmarSansPro' onClick={() => showHideDetails(match.id)}>
        {data?.gamblingTypeId === 2 ?
            <div className="">
                <div className='flex justify-between items-center pl-2 dark:pl-0 pr-3'>
                    <div className='flex'>
                        {
                            match?.gamblingTypeId === 1 ?
                                <span className="dark:pl-3 dark:pr-4">
                                    <GiSoccerBall size={18} className="mr-4 ml-2 dark:m-0" />
                                </span>
                                :
                                <span className="dark:px-3">
                                    <GiStrikingArrows size={18} className="mr-4 ml-2 dark:m-0" />
                                </span>
                        }
                        <h2 className='text-md font-bold'>{match?.gamblingTypeId === 1 ? t("body") : t("maungg")}</h2>
                    </div>
                    <p className="font-dangrek text-sm dark:text-league_text text-background">
                        {
                            moment(new Date(match?.createdDate)).format('DD.MM.YYYY h:mm A')
                        }
                    </p>
                </div>
                <div className="px-5">
                    <div className='grid grid-cols-2 gap-2 pl-8 py-2 items-center mt-2'>
                        <h4 className="text-bg_header dark:text-white font-dangrek">BetID</h4>
                        <p className="text-bg-header text-xs cols-span-2 ">{match?.postingNo}</p>
                    </div>
                    <div className='grid grid-cols-2 gap-4 pl-8 py-1 pt-2'>
                        <h4 className={`text-bg_header dark:text-white ${language === 'en' ? '' : 'font-bold'}`}>{t("betAmount")}</h4>
                        <p className="font-dangrek">{parseInt(match?.amount).toLocaleString()}</p>
                    </div>
                    {
                        match?.gamblingTypeId === 2 ?
                            <div className='grid grid-cols-2 gap-4 pl-8 py-2'>
                                <h4 className={`text-bg_header dark:text-white ${language === 'en' ? '' : 'font-bold'}`}>{t("teamCount")}</h4>
                                <p className="font-dangrek">{match?.teamCount}</p>
                            </div>
                            : null
                    }
                    <div className='flex justify-end text-k_selectionBgColor font-dangrek'>
                        <p>{match?.status === 'Inplay' ? 'Ongoing' : ''}</p>
                    </div>
                </div>
            </div>
            :
            <div></div>
            }
            {
                data?.gamblingTypeId === 1 && expand.includes(match.id) ?
                <div className="">
                    <div className="flex">
                        <div className='flex mb-3'>
                            {
                                match?.gamblingTypeId === 1 ?
                                    <span className="dark:pl-3 dark:pr-4">
                                        <GiSoccerBall size={18} className="mr-4 ml-2 dark:m-0" />
                                    </span>
                                    :
                                    <span className="dark:px-3">
                                        <GiStrikingArrows size={18} className="mr-4 ml-2 dark:m-0" />
                                    </span>
                            }
                            <h2 className='text-md font-bold'>{match?.gamblingTypeId === 1 ? t("body") : t("maungg")}</h2>
                        </div>
                        <div className="w-[70%] text-center flex flex-row justify-end -mt-2 items-center space-x-1 font-dangrek">
                            <p className="font-dangrek">{parseInt(match?.amount).toLocaleString()}</p>
                        </div>
                    </div>
                    <div className="flex w-full justify-center mb-3">
                        <div className="flex justify-between items-center w-[95%]">
                            <div className="ml-8">
                                {data.eventDate && <p className='text-center text-sm font-dangrek'>{(data?.eventDate)}</p>}
                            </div>
                            <div className="w-[20%] text-center flex justify-centeritems-center space-x-1 font-dangrek">
                                <p className=" text-primary dark:text-white text-sm">{data?.homeResult}</p>
                                <p className=" text-primary dark:text-white text-sm">- {data?.awayResult}</p>
                            </div>
                        </div>
                    </div>
                    <div className='flex justify-center items-center w-full dark:pl-0 px-3 bg-slate-100'>
                        <div className=" pt-4 pb-1 w-full dark:bg-gray-800">

                            <div className={`grid grid-cols-[2fr,1fr] ${language === 'en' ? '' : 'font-bold'}`}>
                                <div className="pl-7 pr-1">
                                    <p className={data?.isHomeBodyOdd ? "flex gap-2 text-waterTitle" : "text-waterThree"}>
                                        {data.isHome ? language === 'en' ? data?.bettedTeam : data?.bettedTeamMyan : ""}
                                        {!data.isHome ? language === 'en' ? data?.oppositeTeamName : data?.oppositeTeamNameMyan : ""}
                                        {data?.isHomeBodyOdd ? <p className="text-selectMatch  font-dangrek">« {(data?.home || data?.away) ? data?.bodyOdd : data?.goalOdd}</p> : ''}
                                    </p>
                                    <p className={!data?.isHomeBodyOdd ? "flex gap-2 text-waterTitle mt-2" : "mt-2 text-waterThree"}>
                                        {!data.isHome ? language === 'en' ? data?.bettedTeam : data?.bettedTeamMyan : ""}
                                        {data.isHome ? language === 'en' ? data?.oppositeTeamName : data?.oppositeTeamNameMyan : ""}
                                        {!data?.isHomeBodyOdd && <p className="text-selectMatch font-dangrek">« {(data?.home || data?.away) ? data?.bodyOdd : data?.goalOdd}</p>}
                                    </p>
                                </div>
                                <div>
                                    <h4 className={`text-bg_header dark:text-white ${language === 'en' ? '' : 'font-bold'}`}>{t('choice')}</h4>
                                    <p className={`${language === 'en' ? '' : 'font-bold'} bg-gradient-to-r from-waterFive to-waterTwo bg-clip-text text-transparent`}>
                                        {data.home || data.away ? language === 'en' ? data?.bettedTeam : data?.bettedTeamMyan : ''}
                                        {data.overs ? t("goalOver") : ''}
                                        {data.under ? t("goalUnder") : ''}
                                    </p>
                                </div>

                            </div>

                        </div>
                    </div>

                </div>
                :
                <div>
                    <div className='flex justify-between items-center pl-2 dark:pl-0 pr-3'>
                        <div className='flex'>
                            {
                                match?.gamblingTypeId === 1 ?
                                    <span className="dark:pl-3 dark:pr-4">
                                        <GiSoccerBall size={18} className="mr-4 ml-2 dark:m-0" />
                                    </span>
                                    :
                                    <span className="dark:px-3">
                                        <GiStrikingArrows size={18} className="mr-4 ml-2 dark:m-0" />
                                    </span>
                            }
                            <h2 className='text-md font-bold'>{match?.gamblingTypeId === 1 ? t("body") : t("maungg")}</h2>
                        </div>
                        <p className="font-dangrek text-sm dark:text-league_text text-background">
                            {
                                moment(new Date(match?.createdDate)).format('DD.MM.YYYY h:mm A')
                            }
                        </p>
                    </div>
                    <div className="px-5">
                        <div className='grid grid-cols-2 gap-2 pl-8 py-2 items-center mt-2'>
                            <h4 className="text-bg_header dark:text-white font-dangrek">BetID</h4>
                            <p className="text-bg-header text-xs cols-span-2 ">{match?.postingNo}</p>
                        </div>
                        <div className='grid grid-cols-2 gap-4 pl-8 py-1 pt-2'>
                            <h4 className={`text-bg_header dark:text-white ${language === 'en' ? '' : 'font-bold'}`}>{t("betAmount")}</h4>
                            <p className="font-dangrek">{parseInt(match?.amount).toLocaleString()}</p>
                        </div>
                        {
                            match?.gamblingTypeId === 2 ?
                                <div className='grid grid-cols-2 gap-4 pl-8 py-2'>
                                    <h4 className={`text-bg_header dark:text-white ${language === 'en' ? '' : 'font-bold'}`}>{t("teamCount")}</h4>
                                    <p className="font-dangrek">{match?.teamCount}</p>
                                </div>
                                : null
                        }
                        <div className='flex justify-end text-k_selectionBgColor font-dangrek'>
                            <p>{match?.status === 'Inplay' ? 'Ongoing' : ''}</p>
                        </div>
                    </div>
                            {isLoading && (
                                <div className="bg-gray-200 h-1 w-7 ml-7 rounded-lg  overflow-hidden">
                                    <div className="bg-gradient-to-r from-waterThree to-waterFour h-1 w-1/3 loop-line"></div>
                                </div>
                            )}
                    </div>
                }
        </div>
    );
}

export default SelectedMatchesCard;
